__turbopack_context__.v({
  "active": "PricingCalculator-module__8Q-Pxq__active",
  "addonInfo": "PricingCalculator-module__8Q-Pxq__addonInfo",
  "addonItem": "PricingCalculator-module__8Q-Pxq__addonItem",
  "addonName": "PricingCalculator-module__8Q-Pxq__addonName",
  "addonPrice": "PricingCalculator-module__8Q-Pxq__addonPrice",
  "addonRow": "PricingCalculator-module__8Q-Pxq__addonRow",
  "addonsList": "PricingCalculator-module__8Q-Pxq__addonsList",
  "calculatorWrapper": "PricingCalculator-module__8Q-Pxq__calculatorWrapper",
  "cardHeader": "PricingCalculator-module__8Q-Pxq__cardHeader",
  "checkbox": "PricingCalculator-module__8Q-Pxq__checkbox",
  "counter": "PricingCalculator-module__8Q-Pxq__counter",
  "ctaButton": "PricingCalculator-module__8Q-Pxq__ctaButton",
  "disclaimer": "PricingCalculator-module__8Q-Pxq__disclaimer",
  "emptyState": "PricingCalculator-module__8Q-Pxq__emptyState",
  "freeBonus": "PricingCalculator-module__8Q-Pxq__freeBonus",
  "grid": "PricingCalculator-module__8Q-Pxq__grid",
  "iconWrapper": "PricingCalculator-module__8Q-Pxq__iconWrapper",
  "lockedPack": "PricingCalculator-module__8Q-Pxq__lockedPack",
  "modInfo": "PricingCalculator-module__8Q-Pxq__modInfo",
  "modName": "PricingCalculator-module__8Q-Pxq__modName",
  "modPrice": "PricingCalculator-module__8Q-Pxq__modPrice",
  "moduleCard": "PricingCalculator-module__8Q-Pxq__moduleCard",
  "modulesSection": "PricingCalculator-module__8Q-Pxq__modulesSection",
  "planTabs": "PricingCalculator-module__8Q-Pxq__planTabs",
  "popIn": "PricingCalculator-module__8Q-Pxq__popIn",
  "priceFree": "PricingCalculator-module__8Q-Pxq__priceFree",
  "priceStrikethrough": "PricingCalculator-module__8Q-Pxq__priceStrikethrough",
  "priceWrapper": "PricingCalculator-module__8Q-Pxq__priceWrapper",
  "pulseError": "PricingCalculator-module__8Q-Pxq__pulseError",
  "requiredHighlight": "PricingCalculator-module__8Q-Pxq__requiredHighlight",
  "savingsBox": "PricingCalculator-module__8Q-Pxq__savingsBox",
  "sectionHeader": "PricingCalculator-module__8Q-Pxq__sectionHeader",
  "summaryBody": "PricingCalculator-module__8Q-Pxq__summaryBody",
  "summaryFooter": "PricingCalculator-module__8Q-Pxq__summaryFooter",
  "summaryHeader": "PricingCalculator-module__8Q-Pxq__summaryHeader",
  "summaryList": "PricingCalculator-module__8Q-Pxq__summaryList",
  "summarySection": "PricingCalculator-module__8Q-Pxq__summarySection",
  "summarySticky": "PricingCalculator-module__8Q-Pxq__summarySticky",
  "tabBtn": "PricingCalculator-module__8Q-Pxq__tabBtn",
  "totalPrice": "PricingCalculator-module__8Q-Pxq__totalPrice",
  "totalRow": "PricingCalculator-module__8Q-Pxq__totalRow",
  "validationBox": "PricingCalculator-module__8Q-Pxq__validationBox",
  "validationHeader": "PricingCalculator-module__8Q-Pxq__validationHeader",
});
